import {Theme, alpha} from '@mui/material/styles';

const selectedOverlay = (theme: Theme, extra = 0) =>
  alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + extra);

const stickyActionsSizeSx = {
  width: 64,
  minWidth: 64,
  maxWidth: 64,
  px: 0.25,
  boxSizing: 'border-box',
  textAlign: 'center',
  whiteSpace: 'nowrap'
};

/** Keeps the actions cell pinned to the right edge of a horizontally scrolling table. */
export const stickyActionsCellSx = {
  position: 'sticky',
  right: 0,
  zIndex: 2,
  bgcolor: 'background.paper',
  boxShadow: (theme: Theme) => `inset 1px 0 0 ${theme.palette.divider}`,
  '.MuiTableRow-hover:hover &': {
    backgroundImage: (theme: Theme) => `linear-gradient(${theme.palette.action.hover}, ${theme.palette.action.hover})`
  },
  '.Mui-selected &': {
    backgroundImage: (theme: Theme) => `linear-gradient(${selectedOverlay(theme)}, ${selectedOverlay(theme)})`
  },
  '.Mui-selected.MuiTableRow-hover:hover &': {
    backgroundImage: (theme: Theme) => {
      const overlay = selectedOverlay(theme, theme.palette.action.hoverOpacity);
      return `linear-gradient(${overlay}, ${overlay})`;
    }
  }
};

export const stickyActionsCompactSx = {
  ...stickyActionsCellSx,
  ...stickyActionsSizeSx
};

export const stickyActionsHeaderSx = {
  ...stickyActionsCompactSx,
  zIndex: 3,
  backgroundImage: 'none',
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1.2
};
